export default "__VITE_ASSET__CrYlLeFt__"